<template>
  <v-dialog :value="value" max-width="360" @input="$emit('input', $event)">
    <div class="verification-popup">
      <strong class="verification-popup__title">실명인증</strong>
      <p class="verification-popup__text">
        계약자 정보 변경을 위해 실명인증이 필요합니다.<br />
        진행하시겠습니까?
      </p>

      <div class="verification-popup__footer">
        <button
          type="button"
          class="verification-popup__button is-cancel"
          @click="$emit('input', false)"
        >
          취소
        </button>
        <button
          type="button"
          class="verification-popup__button is-confirm"
          @click="$emit('confirm')"
        >
          확인
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  // 계약자 정보 변경 전에 실명인증 필요 여부를 한 번 더 확인하는 다이얼로그
  name: "ContractorInfoVerificationDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.verification-popup {
  border-radius: 18px;
  background-color: #ffffff;
  padding: 28px 24px 22px;
}

.verification-popup__title {
  display: block;
  margin-bottom: 14px;
  text-align: center;
  color: #232323;
  font-size: 22px;
  font-weight: 700;
}

.verification-popup__text {
  margin: 0 0 22px;
  text-align: center;
  color: #232323;
  font-size: 15px;
  line-height: 1.6;
  word-break: keep-all;
}

.verification-popup__footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.verification-popup__button {
  min-width: 96px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 700;
}

.verification-popup__button.is-cancel {
  background-color: #d9d9d9;
  color: #222222;
}

.verification-popup__button.is-confirm {
  background-color: #e66a1f;
  color: #ffffff;
}
</style>
